import {img_300 , unavailable} from "../Config/Config";
import "../SingleContent/SingleContent.css";
import { Badge } from "@material-ui/core";
import ContentModal from "../ContentModal/ContentModal";

const SingleContent = ({id, title , poster,date , media_type,vote_average}) => {
    return (
        <ContentModal media_type={media_type} id={id}>
          <Badge
            badgeContent={vote_average}
            color={vote_average > 6 ? "primary" : "secondary"}
          />
          <img
            className="poster"
            src={poster ? `${img_300}${poster}` : unavailable}
            alt={title}
          />
          <b className="title">{title}</b>
          <div className = 'span'>
          <span className="subTitle">
            {media_type === "tv" ? "TV Series" : "Movie"}
            <span className="subTitle">{date}</span>
          </span>
          </div>
        </ContentModal>
      );
    };

export default SingleContent
